import React from 'react';
import { FaIcon, FaIcons } from '@innovationnorway/component-library';

const ToastContent = ({ title, text, success }: { title: string; text: string; success: boolean }) => {
  return (
    <div className="display--flex gap--2">
      <FaIcon
        className={`${success ? 'color--in-green-200' : 'color--red'}`}
        name={success ? FaIcons.CheckCircleLight : FaIcons.ExclamationCircleLight}
      />
      <div>
        <div className="margin-bottom--0 font-size--large font-weight--bold color--in-black-100">{title}</div>
        <div className="color--in-black-100 font-size--medium">{text}</div>
      </div>
    </div>
  );
};

export default ToastContent;
